module.exports = __webpack_public_path__ + "img/roland.ec27f56c.png";